"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartItemDropdownList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));
var _cartItemDropdownListItem = _interopRequireDefault(require("./cartItemDropdownListItem"));
var _cartItemChild = _interopRequireDefault(require("./cartItemChild"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CartItemDropdownList = exports.CartItemDropdownList = function CartItemDropdownList(props) {
  var _useState = (0, _react.useState)(props.open),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var internalDisplayVerticalLine = props.displayVerticalLine;
  var getCartItemTotal = function getCartItemTotal(cartItem) {
    var qty = cartItem.qty;
    var kitItemQty = cartItem.kitItemQty;
    var originalComponentQuantity = qty / kitItemQty;
    var itemTotal = cartItem.qty * cartItem.sellPrice;
    if (props.submittedKitQty) {
      cartItem.submittedKitQty = props.submittedKitQty;
      originalComponentQuantity = originalComponentQuantity * props.submittedKitQty;
      itemTotal = originalComponentQuantity * cartItem.sellPrice;
    }
    return itemTotal;
  };
  var getCartItemDiscountTotal = function getCartItemDiscountTotal(cartItem) {
    var discountTotal = -1;
    if (cartItem.discount && cartItem.discountType === 1 && cartItem.discount > 0) {
      discountTotal = getCartItemTotal(cartItem) - cartItem.discount;
    }
    return discountTotal;
  };
  var mapChildCartItems = function mapChildCartItems(childrenItems) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, childrenItems.map(function (childItem, index) {
      var key = "cart.".concat(childItem.cartLineRecId, ".").concat(index);
      var itemTotal = getCartItemTotal(childItem);
      var discountTotal = getCartItemDiscountTotal(childItem);
      return /*#__PURE__*/_react["default"].createElement(_cartItemDropdownListItem["default"], {
        key: key
      }, /*#__PURE__*/_react["default"].createElement(_cartItemChild["default"], {
        cartItem: childItem,
        itemTotal: itemTotal,
        discountTotal: discountTotal,
        useMobile: props.alwaysFullWidth
      }));
    }));
  };
  var chevronBtnDivClasses = props.alwaysFullWidth ? "offset-6 col-6" : "offsetm-6 colm-6";
  var chevronLeftOrRightCls = props.chevronLeft ? "wbmcid-chevron-left" : "wbmcid-chevron-right";
  var widthCls = props.alwaysFullWidth ? "wbmcid-full-width" : "wbmcid-medium-width";
  var chevronDownCls = "wbmcid-chevron ".concat(open ? "wbmcid-is-open" : '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters wbmcid-dropdown-button ".concat(chevronLeftOrRightCls, " ").concat(widthCls)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: chevronBtnDivClasses
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    className: internalDisplayVerticalLine ? "" : "no-vert-line"
  }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    className: chevronDownCls
  }), internalDisplayVerticalLine && /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-chevron-d wbmcid-chevron"
  }), props.buttonContent))), open && props.childrenItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-dropdown-wrapper"
  }, mapChildCartItems(props.childrenItems), props.customeText && /*#__PURE__*/_react["default"].createElement(_cartItemDropdownListItem["default"], {
    key: "customeTextKey"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-text-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ErrorOutline["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "custom-text"
  }, props.customeText)))));
};
//# sourceMappingURL=cartItemDropdownList.js.map